module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/3/4-8bf47b10496ef1280e18ebb6ec630e04.jpg";